import { common as frCommon } from './fr/common';
import { common as arCommon } from './ar/common';

const messages = {
  fr: {
    common: frCommon
  },
  ar: {
    common: arCommon
  }
};

export default messages;
